// extracted by mini-css-extract-plugin
module.exports = {"checkmark":"_39Q2kN","icon":"_2dH5s9","brandWhite":"_2n50CI","transparentWhite":"_2Q56QF","whiteBrand":"_1DKDx5","shine-lines":"_3iGmra"};